import React from 'react';

function FamilyMemberRoster({ members, selectedMemberId, onSelect, showRoleBadge = true }) {
  return (
    <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
      <button
        onClick={() => onSelect && onSelect(null)}
        style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem',
          background: selectedMemberId === null ? 'var(--color-primary-subtle, #f0f7ff)' : 'none',
          border: selectedMemberId === null ? '2px solid var(--color-primary, #4a90d9)' : '1px solid #ddd',
          borderRadius: '8px', padding: '0.5rem 0.75rem', cursor: 'pointer', minWidth: '60px',
        }}
      >
        <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#ddd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem' }}>
          👨‍👩‍👧‍👦
        </div>
        <span style={{ fontSize: '0.75em' }}>All</span>
      </button>

      {members.filter(m => m.status !== 'removed').map(member => {
        const initial = (member.username || '?')[0].toUpperCase();
        const isSelected = selectedMemberId === member.user_id;

        return (
          <button
            key={member.user_id}
            onClick={() => onSelect && onSelect(member.user_id)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem',
              background: isSelected ? 'var(--color-primary-subtle, #f0f7ff)' : 'none',
              border: isSelected ? '2px solid var(--color-primary, #4a90d9)' : '1px solid #ddd',
              borderRadius: '8px', padding: '0.5rem 0.75rem', cursor: 'pointer', minWidth: '60px',
            }}
          >
            {member.headshot_url ? (
              <img
                src={member.headshot_url}
                alt={member.username}
                style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover' }}
              />
            ) : (
              <div style={{
                width: '36px', height: '36px', borderRadius: '50%',
                background: 'var(--color-primary, #4a90d9)', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 'bold', fontSize: '1rem',
              }}>
                {initial}
              </div>
            )}
            <span style={{ fontSize: '0.75em', maxWidth: '64px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {member.username}
            </span>
            {showRoleBadge && member.role === 'organizer' && (
              <span style={{ fontSize: '0.65em', background: '#dbeafe', color: '#1d4ed8', borderRadius: '8px', padding: '1px 6px' }}>
                Organizer
              </span>
            )}
            {member.status === 'grace_period' && (
              <span style={{ fontSize: '0.65em', background: '#fff7ed', color: '#c2410c', borderRadius: '8px', padding: '1px 6px' }}>
                Grace period
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default FamilyMemberRoster;
